export function replaceLocaleInPath(path: string, locale: string): string {
   if (path[0] !== '/') {
      return replaceLocaleInPath(`/${path}`, locale);
   }
   return `${path.substr(0, 1)}${locale}${path.substr(3)}`;
}

/**
 * Helper to check if there are parameters in the url
 *
 * @param uri
 * @returns {boolean}
 */
const hasQuestionMark = uri => uri.indexOf('?') !== -1;

/**
 * Add a parameter to the url
 *
 * @param url
 * @param key
 * @param value
 * @returns {*}
 */
export function addUrlParam(url, {key, value}) {
    if (!url || !key || !value) {
        return url;
    }

    return hasQuestionMark(url)
        ? `${url}&${key}=${value}`
        : `${url}?${key}=${value}`;
}

/**
 * Add multiple parameters to the url
 * 'params' must be an object
 *
 * @param url
 * @param params
 * @returns {*}
 */
export function addUrlParams(url, params) {
    let urlWithParams = url;

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            urlWithParams = addUrlParam(urlWithParams, {key, value: params[key]});
        }
    }

    return urlWithParams;
}

export const query = variable => {
    let query = window.location.search;
    let vars = query.replace('?', '').split("&");
    for (let i=0;i<vars.length;i++) {
        let pair = vars[i].split("=");
        if(pair[0] === variable){return pair[1];}
    }
    return(false);
}

export const isPathMatched = variable => {
    const path = window.location.href;
    return path.includes(variable);
}